const StatTile = ({ label, value, icon, loading }) => (
  <div className="admin-home-stat">
    <div className="admin-home-stat__top">
      <span className="admin-home-stat__label">{label}</span>
      <i className={`${icon} admin-home-stat__icon`} aria-hidden="true" />
    </div>
    {loading ? (
      <span className="admin-home-skeleton admin-home-skeleton--value" />
    ) : (
      <span className="admin-home-stat__value">{value}</span>
    )}
  </div>
);

export default StatTile;
